import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import { CreateOrEditScheduledTriggerPage } from "./CreateOrEditScheduledTriggerPage";
interface CreateDeploymentScheduledTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function CreateDeploymentScheduledTriggerPage({ spaceId, projectSlug }: CreateDeploymentScheduledTriggerPageProps) {
    return <CreateOrEditScheduledTriggerPage create triggerActionCategory={TriggerActionCategory.Deployment} spaceId={spaceId} projectSlug={projectSlug}/>;
}
